var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHandbags = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Products-Purse--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Products Purse Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.38 17.48 21 9.72a1.44 1.44 0 0 0 -1.42 -1.18H4.43A1.44 1.44 0 0 0 3 9.72l-1.38 7.76a5.14 5.14 0 0 0 1.13 4.19 5.21 5.21 0 0 0 4 1.87h10.48a5.25 5.25 0 0 0 4 -1.87 5.14 5.14 0 0 0 1.15 -4.19ZM6 13.27a0.75 0.75 0 0 1 0 -1.5h12a0.75 0.75 0 0 1 0 1.5H9.46a0.25 0.25 0 0 0 -0.25 0.25v2a0.75 0.75 0 1 1 -1.5 0v-2a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46 7.54a1 1 0 0 0 1 -1c0 -4.32 5.32 -4.94 7.65 -3a3.76 3.76 0 0 1 1.35 3 1 1 0 0 0 2 0c0 -4 -3.27 -6.08 -6.5 -6.08s-6.5 2.09 -6.5 6.08a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHandbags);
export default ForwardRef;